import styled, { css } from 'styled-components';

export const MessageWarning = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.$yellow};
  border-top: 1px solid ${(props) => props.theme.$yellow};
`;

export const LotsSelector = styled.div<{ expanded?: boolean }>`
  display: flex;
  align-items: start;
  width: 100%;

  .lots-container {
    display: flex;
    align-items: center;
    margin-top: 0.25rem;
    gap: 4px;
    flex-wrap: wrap;
    overflow: ${({ expanded }) => (expanded ? 'visible' : 'hidden')};
    max-height: ${({ expanded }) => (expanded ? 'none' : '29px')};
  }

  .lots-label {
    margin-right: 0.5rem;
    white-space: nowrap;
  }

  .lot-btn {
    min-width: 30px;
    padding: 2px 6px;
    font-size: 13px;
    position: relative;
  }

  .lot-btn-todos {
    min-width: 42px;
    padding: 2px 8px;
    font-size: 13px;
  }

  .lot-new-msg {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: red;
  }

  .lots-actions {
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 8px;
    flex-shrink: 0;
    height: 29px;
  }

  .lots-overflow {
    font-size: 13px;
  }

  .lots-apps-btn {
    padding: 2px 6px;
  }

  .lots-apps-icon {
    font-size: 18px;
    vertical-align: middle;
  }

  .lots-divider {
    border-left: 1px solid #ccc;
    height: 20px;
  }

  .lots-edit-btn {
    white-space: nowrap;
  }
`;

export const tradingMessagesStyles = css`
  .infinite-scroll-component {
    overflow-x: hidden !important;
  }
  .monitoring-date {
    font-size: 0.9em;
  }
  .monitoring-body {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: ${(props) => props.theme.$gray200};
  }
  .monitoring-body.message-list {
    display: flex;
    flex-direction: column-reverse;
  }
  @media only screen and (max-width: 768px) {
    .monitoring-body {
      height: 90vh;
    }
  }
  @-moz-document url-prefix() {
    .monitoring-body {
      scrollbar-width: thin;
      scrollbar-color: ${(props) => props.theme.$gray500} #fff;
      padding-right: 0.5rem;
      box-sizing: content-box;
    }
  }
  .monitoring-body::-webkit-scrollbar {
    width: 1rem;
  }
  .monitoring-body::-webkit-scrollbar-track {
    border-left: 0;
  }
  .monitoring-body::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background-color: ${(props) => props.theme.$gray500};
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    border-right: 0.3rem solid ${(props) => props.theme.$gray200};
    border-left: 0.3rem solid ${(props) => props.theme.$gray200};
    border-top: 0.2rem solid ${(props) => props.theme.$gray200};
    border-bottom: 0.2rem solid ${(props) => props.theme.$gray200};
  }
`;
